import Layout from '@/page/index/'
export default [{
  path: '/state',
  name: '状态页',
  component:  () =>
    import('@/page/success/state')
},{
  path: '/',
  name: '主页',
  redirect: '/wel'
},
//  {
//   path: '/test',
//   component: Layout,
//   redirect: '/test/index',
//   children: [{
//     path: 'index',
//     name: '测试',
//     component: () =>
//       import('@/views/test/test.vue')
//   }]
// },
{
  path: '/wel',
  component: Layout,
  redirect: '/wel/index',
  children: [{
    path: 'index',
    name: '首页',
    component: () =>
      import('@/views/dashboard/index')
  }]
}, {
  path: '*',
  redirect: '/404',
  hidden: true
}, {
  path: '/lock',
  name: '锁屏页',
  component:  () =>
    import('@/page/lock/index')
}, {
  path: '/info',
  component: Layout,
  redirect: '/info/index',
  children: [{
    path: 'index',
    name: '个人信息',
    component:  () =>
      import('@/views/admin/user/info')
  }]
},  {
  path: '/companyWorker',
  component: Layout,
  redirect: '/companyWorker/index',
  children: [{
    path: 'index',
    name: '企业员工信息',
    companyId : '',
    component:  () =>
      import('@/views/userManagement/business/info')
  }]
}, {
  path: '/user',
  component: Layout,
  redirect: '/user/index',
  children: [{
    path: 'index',
    name: '个人信息修改资料',
    component:  () =>
      import('@/views/admin/user/info')
  }]
},{
  path: '/404',
  component:  () =>
    import('@/components/error-page/404'),
  name: '404'
}, {
  path: '/403',
  component:  () =>
    import('@/components/error-page/403'),
  name: '403'
}, {
  path: '/500',
  component:  () =>
    import('@/components/error-page/500'),
  name: '500'
}, {
  path: '/appIframe',
  component: Layout,
  redirect: '/appIframe',
  meta: {
    keepAlive: true
  },
  children: [{
    path: ':routerPath',
    name: 'iframe',
    component:  () =>
      import('@/components/iframe/main'),
    props: true
  }]
}]
